import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnInit,
  ChangeDetectionStrategy
} from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  DxPopupModule,
  DxTagBoxModule,
  DxSelectBoxModule,
  DxCheckBoxModule,
} from "devextreme-angular";
import { SvgIconComponent } from "src/app/components/svg-icon/svg-icon.component";
import { GpdDateboxComponent } from "src/app/components/gpd-datebox/gpd-datebox.component";
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";
import { UserAvatarComponent } from "src/app/components/user-avatar/user-avatar.component";
import { SparkBoardFilterState, tagColor } from "../../project-hub.types";
import { DxoPositionModule } from "devextreme-angular/ui/nested";
import deMessages from "devextreme/localization/messages/de.json";
import { locale, loadMessages } from "devextreme/localization";

import { SearchableDropdownDirective } from '../../../../../../../directives/searchable-dropdown.directive';
@Component({
    selector: "app-spark-filter",
    imports: [
        CommonModule,
        DxPopupModule,
        DxTagBoxModule,
        DxSelectBoxModule,
        DxCheckBoxModule,
        SvgIconComponent,
        GpdDateboxComponent,
        GpdButtonComponent,
        UserAvatarComponent,
        DxoPositionModule,
        SearchableDropdownDirective,
    ],
    templateUrl: "./spark-filter.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./spark-filter.component.css"]
})
export class SparkFilterComponent {
  @Input() filterState: SparkBoardFilterState = {
    period: { from: null, to: null },
    tags: [],
    person: null,
    unread: false,
  };
  @Input() sparkTags: { id: number; name: string; color?: tagColor }[] = [];
  @Input() users: any[] = [];

  @Output() filterChanged = new EventEmitter<SparkBoardFilterState>();

  @ViewChild("filterIcon", { static: false }) filterIcon: ElementRef;

  showFilterMenu: boolean = false;
  unsavedFilterState: SparkBoardFilterState = {
    period: { from: null, to: null },
    tags: [],
    person: null,
    unread: false,
  };
  isHiding: boolean = false;
  isFilterApplied: boolean = false;

  constructor(/* ...existing dependencies... */) {
    // Load German localization for DevExtreme
    loadMessages(deMessages);
    locale("de");
  }

  toggleMenu() {
    this.showFilterMenu = !this.showFilterMenu;
    this.unsavedFilterState = this.filterState;
  }

  resetAllFilters() {
    if (this.unsavedFilterState) {
      this.unsavedFilterState.period.from = null;
      this.unsavedFilterState.period.to = null;
      this.unsavedFilterState.tags = [];
      this.unsavedFilterState.person = null;
      this.unsavedFilterState.unread = false;
    }
    this.filterState = this.unsavedFilterState;
    this.filterChanged.emit(this.filterState);
    this.isFilterApplied = false;
  }

  applyFilters() {
    this.filterState = this.unsavedFilterState;
    this.filterChanged.emit(this.filterState);
    this.showFilterMenu = false;
    this.unsavedFilterState = this.filterState;
    this.setIsFilterAppliedProperty();
  }

  setIsFilterAppliedProperty() {
    this.isFilterApplied =
      !!this.filterState.period.from ||
      !!this.filterState.period.to ||
      (this.filterState.tags && this.filterState.tags.length > 0) ||
      !!this.filterState.person ||
      this.filterState.unread;
  }

  resetPeriodFilter() {
    if (this.unsavedFilterState) {
      this.unsavedFilterState.period.from = null;
      this.unsavedFilterState.period.to = null;
    }
  }

  resetTagsFilter() {
    if (this.unsavedFilterState) {
      this.unsavedFilterState.tags = [];
    }
  }

  resetPersonFilter() {
    if (this.unsavedFilterState) {
      this.unsavedFilterState.person = null;
    }
  }
}
